// Module
var code = "<div class=\"pad24 inline-block\" style=\"width:300px\"> <p>Choose a password that's hard to guess. Use uncommon words or phrases and mixed UppercASe. Add numbers and symbols and avoid sequences like 123, asdf, or zzzz.</p> </div> ";
// Exports
export default code;